"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSitewideMessaging = exports.getTotalPotentialValueDiscount = exports.applyDiscounts = exports.getDiscounts = exports.getDiscountAmount = exports.conditionCheckForParentSkus = void 0;
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const promotions_configs_1 = require("./promotions.configs");
const conditionCheckForParentSkus = (cartItems = [], valueDiscount) => {
    const { conditionSkuSet, conditionQuantity = 1 } = valueDiscount;
    // account for quantity condition first
    const workingCartItems = cartItems.filter(item => item.quantity >= conditionQuantity);
    if (workingCartItems.length > 0) {
        // if condition applies, return key
        const parentSkus = workingCartItems.map(item => item.parentSku);
        const conditionQualifyResult = conditionSkuSet.map(set => {
            return set.some(sku => parentSkus.includes(sku));
        });
        return conditionQualifyResult.every(result => result);
    }
    return false;
};
exports.conditionCheckForParentSkus = conditionCheckForParentSkus;
const getDiscountAmount = (discountValue, itemSku) => {
    if (typeof discountValue === 'object') {
        // TODO: add product size to cart item response object
        const sizeKey = Object.keys(discountValue).reverse().find(key => itemSku.includes(key));
        return discountValue[sizeKey];
    }
    return discountValue;
};
exports.getDiscountAmount = getDiscountAmount;
const getSitewideMessaging = (sitewidePromoData) => {
    const messagingConfig = {
        sitewide: null,
        saleBannerHeading: null,
        saleBannerSubtitle: null,
        pdp: {},
        plp: {},
        bmsmPanel: {},
        valuePropsPanel: {}
    };
    if (!(sitewidePromoData && sitewidePromoData.messaging)) {
        return messagingConfig;
    }
    const { messaging, bmsmPanelMessaging = {}, valuePropsPanelMessaging = {} } = sitewidePromoData;
    messagingConfig.bmsmPanel = bmsmPanelMessaging;
    messagingConfig.valuePropsPanel = valuePropsPanelMessaging;
    messaging.forEach((messageSlot) => {
        const { slot, slotCondition } = messageSlot;
        switch (slot) {
            case promotions_configs_1.slots.sitewideBanner: {
                messagingConfig.sitewide = { ...messageSlot };
                break;
            }
            case promotions_configs_1.slots.saleBannerHeading: {
                messagingConfig.saleBannerHeading = { ...messageSlot };
                break;
            }
            case promotions_configs_1.slots.saleBannerSubtitle: {
                messagingConfig.saleBannerSubtitle = { ...messageSlot };
                break;
            }
            case promotions_configs_1.slots.pdpDefault: {
                messagingConfig.pdp.default = { ...messageSlot };
                break;
            }
            case promotions_configs_1.slots.pdpSKU:
            case promotions_configs_1.slots.pdpCategory: {
                messagingConfig.pdp[slotCondition] = { ...messageSlot };
                break;
            }
            default: {
                break;
            }
        }
    });
    return messagingConfig;
};
exports.getSitewideMessaging = getSitewideMessaging;
const getTotalPotentialValueDiscount = (selectedProductSkus, valueDiscountDefinitions) => {
    const potentialValueDiscountAmounts = [];
    Object.keys(valueDiscountDefinitions).forEach(key => {
        const valueDiscount = valueDiscountDefinitions[key];
        const potentialDiscountedItem = selectedProductSkus.find(product => valueDiscount.discountedProductSkus.includes(product.parentSku));
        potentialDiscountedItem && potentialValueDiscountAmounts.push(getDiscountAmount(valueDiscount.discountValue, potentialDiscountedItem.sku));
    });
    const totalPotentialValueDiscount = potentialValueDiscountAmounts.length < 2 ? potentialValueDiscountAmounts[0] : potentialValueDiscountAmounts.reduce((a, b) => a + b);
    return totalPotentialValueDiscount;
};
exports.getTotalPotentialValueDiscount = getTotalPotentialValueDiscount;
const getSurplusSaleDiscount = (surplusDiscountDefinitions, sku, productCode, price) => {
    let surplusDiscountAmount = 0;
    let label = '';
    const discount = surplusDiscountDefinitions[sku] || surplusDiscountDefinitions[productCode];
    if (discount) {
        const { discount: discountAmount, discountValueType, label: discountLabel } = discount;
        if (discountValueType === 'fixed_cart') {
            surplusDiscountAmount = discountAmount;
        }
        else if (discountValueType === 'percent') {
            surplusDiscountAmount = price * (discountAmount / 100);
        }
        label = discountLabel;
    }
    return { surplusDiscountAmount, label };
};
const getPillowPairMultiple = (valueDiscount, discountedItem) => {
    const { discountKey, conditionQuantity } = valueDiscount;
    if (discountKey !== 'pillowPair') {
        return 1;
    }
    return Math.floor(discountedItem.quantity / conditionQuantity);
};
const getValueDiscounts = (valueDiscountDefinitions, selectedProducts) => {
    const valueDiscounts = {};
    Object.values(valueDiscountDefinitions).forEach(valueDiscount => {
        const discountedItem = selectedProducts.find(product => valueDiscount.discountedProductSkus.includes(product.parentSku));
        const valueDiscountAmount = discountedItem && getDiscountAmount(valueDiscount.discountValue, discountedItem.sku);
        if (valueDiscountAmount) {
            const discountApplies = conditionCheckForParentSkus(selectedProducts, valueDiscount);
            const discountMultiple = getPillowPairMultiple(valueDiscount, discountedItem);
            if (discountApplies) {
                valueDiscounts[discountedItem.sku] = {
                    sku: discountedItem.sku,
                    discountAmount: valueDiscountAmount * discountMultiple,
                    label: valueDiscount.label,
                    discountType: 'value'
                };
            }
        }
    });
    return valueDiscounts;
};
/**
 * This function handles discounts of free "Included" products. Right now this is
 * limited to Upper-Flex sheets for Solaire and Zenhaven Upper-Flex mattress sizes.
 * Ideally this will be dynamic, but this works for now for the limited number of cases.
 * There are also cases to handle both the new model and old model add on components.
 *
 * @param {{
 *   upperFlex: { sheetsSolaire: String, upperFlexSheetSkus: Array<String>, upperFlexMattressSkus: Array<String> }
 * }} includedDiscountDefinitions
 * @param {Array<{ sku: String, parentSku: String, quantity: Number, category: String, price: Number}>} selectedProducts
 */
const getIncludedDiscounts = (includedDiscountDefinitions, selectedProducts) => {
    const includedDiscounts = {};
    const upperFlexData = (includedDiscountDefinitions === null || includedDiscountDefinitions === void 0 ? void 0 : includedDiscountDefinitions.upperFlex) || {};
    const { sheetsSolaire, upperFlexSheetSkus, upperFlexMattressSkus, label } = upperFlexData;
    const upperFlexMattressProducts = selectedProducts.filter(product => upperFlexMattressSkus === null || upperFlexMattressSkus === void 0 ? void 0 : upperFlexMattressSkus.includes(product.sku));
    if (upperFlexMattressProducts.length === 0)
        return {}; // short circuit if no mattress with upper-flex SKU is in cart
    /**
     * Since there's an upper-flex mattress added, we can apply the discount to all upper-flex sheets.
     * We don't need to check for specific SKUs because the cart price rule ensures that sizes must match in cart
     * and the PDP addon components don't allow for size changes before cart so they're in sync prior to cart.
     */
    selectedProducts.forEach(({ parentSku, sku, price }) => {
        if (parentSku === sheetsSolaire || upperFlexSheetSkus.includes(sku)) {
            includedDiscounts[sku] = { sku, discountAmount: price, label: label || 'Sheet Set Discount', discountType: 'included' };
        }
    });
    return includedDiscounts;
};
/**
 * Surplus discounts are discounts defined for a specific product variant due to excess inventory
 * it should take into account the quantity for the discount as you can add several products for bedding
 * in a single interaction pre-cart.
 */
const getSurplusDiscounts = (surplusDiscountDefinitions, selectedProducts) => {
    const surplusSaleDiscount = {};
    if (selectedProducts.length > 0) {
        selectedProducts.forEach(({ sku, parentSku, price, quantity }) => {
            const { surplusDiscountAmount, label } = getSurplusSaleDiscount(surplusDiscountDefinitions, sku, parentSku, price);
            if (surplusDiscountAmount) {
                surplusSaleDiscount[sku] = { sku, discountAmount: surplusDiscountAmount * quantity, label, discountType: 'surplus' };
            }
        });
    }
    return surplusSaleDiscount;
};
const getFixedPromoDiscount = (fixedDiscount = 0, fixedThreshold = 0, productSetSubtotal = 0, mattressInProductSet = false, productPrice = 0) => {
    if (mattressInProductSet && productSetSubtotal >= fixedThreshold) {
        return (productPrice / productSetSubtotal) * fixedDiscount;
    }
    return 0;
};
const getBMSMPromoDiscount = (bmsmAmounts = [], productSetSubtotal = 0, productPrice = 0) => {
    if (!bmsmAmounts) {
        return 0;
    }
    for (let i = 0; i < bmsmAmounts.length; i++) {
        const [discount, lowThreshold, highThreshold] = bmsmAmounts[i];
        const meetsLowThreshold = productSetSubtotal >= lowThreshold;
        const underHighThreshold = highThreshold ? productSetSubtotal < highThreshold : true;
        if (meetsLowThreshold && underHighThreshold) {
            return (productPrice / productSetSubtotal) * discount;
        }
    }
    return 0;
};
const getPercentPromoDiscount = (percentAmounts = [], productSetSubtotal = 0, productPrice = 0) => {
    if (!percentAmounts) {
        return 0;
    }
    for (let i = 0; i < percentAmounts.length; i++) {
        const [discount, lowThreshold, highThreshold] = percentAmounts[i];
        const meetsLowThreshold = productSetSubtotal >= lowThreshold;
        const underHighThreshold = highThreshold ? productSetSubtotal < highThreshold : true;
        if (meetsLowThreshold && underHighThreshold) {
            return discount / 100 * productPrice;
        }
    }
    return 0;
};
const getProductSitewideDiscount = (sitewidePromoData, subtotal, mattressSelected, productPrice) => {
    const { promoProfile = {}, fixedDiscountAmount = 0, fixedDiscountThreshold = 0, bmsmAmounts = [], percentAmounts = [] } = sitewidePromoData;
    const { isFixedPromo, isBMSMPromo, isPercentagePromo } = promoProfile;
    if (isFixedPromo) {
        // TODO: add a flag in prismic for requiring a mattress in cart and make the mattress check dynamic
        return getFixedPromoDiscount(fixedDiscountAmount, fixedDiscountThreshold, subtotal, mattressSelected, productPrice);
    }
    if (isBMSMPromo) {
        return getBMSMPromoDiscount(bmsmAmounts, subtotal, productPrice);
    }
    if (isPercentagePromo) {
        return getPercentPromoDiscount(percentAmounts, subtotal, productPrice);
    }
    return 0;
};
const getSitewidePromoDiscount = (sitewidePromoData = {}, selectedProducts = []) => {
    var _a;
    const subtotal = selectedProducts.reduce((acc, product) => acc + (product.price * product.quantity), 0);
    const mattressSelected = Boolean(selectedProducts.find(product => product.category === 'mattresses'));
    const sitewideLabel = sitewidePromoData.shortPromotionName || ((_a = sitewidePromoData === null || sitewidePromoData === void 0 ? void 0 : sitewidePromoData.labels) === null || _a === void 0 ? void 0 : _a[0]);
    const sitewideDiscounts = {};
    selectedProducts.forEach(({ sku, price, quantity, priceMinusDiscounts }) => {
        var _a;
        // for percent promotions we want to subtract the value and surplus sales from the product price before calculating the percent discount
        const productPrice = ((_a = sitewidePromoData === null || sitewidePromoData === void 0 ? void 0 : sitewidePromoData.promoProfile) === null || _a === void 0 ? void 0 : _a.isPercentagePromo) && priceMinusDiscounts ? priceMinusDiscounts : price;
        const sitewideDiscountAmount = getProductSitewideDiscount(sitewidePromoData, subtotal, mattressSelected, productPrice * quantity);
        if (sitewideDiscountAmount) {
            sitewideDiscounts[sku] = { sku, discountAmount: sitewideDiscountAmount, label: sitewideLabel, discountType: 'sitewide' };
        }
    });
    return sitewideDiscounts;
};
/**
 * @param {{}} promotionData
 * @param {Array<{ sku: String, parentSku: String, quantity: Number, category: String, price: Number}>} selectedProducts
 * @param {{ roundDiscount: Boolean }} options
 */
const getDiscounts = (promotionData = {}, selectedProducts = [], options = {}) => {
    const { roundDiscount = true } = options;
    const { sitewidePromo, valueDiscountDefinitions, surplusDiscountDefinitions, cartPriceDiscounts } = promotionData;
    const { promoProfile = {}, couponCode = '' } = sitewidePromo;
    const { isPercentagePromo } = promoProfile;
    const fullPrice = selectedProducts.reduce((acc, product) => acc + (product.price * product.quantity), 0);
    const valueDiscounts = getValueDiscounts(valueDiscountDefinitions, selectedProducts);
    const surplusDiscounts = getSurplusDiscounts(surplusDiscountDefinitions, selectedProducts);
    const includedDiscounts = getIncludedDiscounts(cartPriceDiscounts, selectedProducts);
    // store price minus value/surplus discounts so that percent promos can be calculated correctly
    let newSelectedProducts = [...selectedProducts];
    if (isPercentagePromo) {
        newSelectedProducts = selectedProducts.map((product) => {
            var _a, _b;
            const { sku, price, quantity } = product;
            if (sku in valueDiscounts || sku in surplusDiscounts) {
                const valueDiscountAmount = (((_a = valueDiscounts[sku]) === null || _a === void 0 ? void 0 : _a.discountAmount) && (valueDiscounts[sku].discountAmount / quantity)) || 0;
                const surplusDiscountAmount = (((_b = surplusDiscounts[sku]) === null || _b === void 0 ? void 0 : _b.discountAmount) && (surplusDiscounts[sku].discountAmount / quantity)) || 0;
                return {
                    ...product,
                    priceMinusDiscounts: price - valueDiscountAmount - surplusDiscountAmount
                };
            }
            return product;
        });
    }
    const sitewideDiscounts = getSitewidePromoDiscount(sitewidePromo, newSelectedProducts);
    let valueDiscountsSum = Object.values(valueDiscounts).reduce((acc, discount) => acc + discount.discountAmount, 0);
    let surplusDiscountsSum = Object.values(surplusDiscounts).reduce((acc, discount) => acc + discount.discountAmount, 0);
    // TODO: Need to fix the logic to properly add the additional discounts in percent off promos
    let sitewideDiscountsSum = Object.values(sitewideDiscounts).reduce((acc, discount) => acc + discount.discountAmount, 0);
    let includedDiscountsSum = Object.values(includedDiscounts).reduce((acc, discount) => acc + discount.discountAmount, 0);
    let discountAmount = 0;
    /**
     * Normally, all discounts would be included on every selected product.
     * The exception is included discounts (i.e. free sheet with upper-flex mattresses).
     * In the old model, there was a separate SKU for the free sheet (organic-cotton-sheets-solaire).
     * In the new model, the sheet uses the same SKU in a different addon component. This means that if a user
     * adds an extra sheet, there will be two instances of the same SKU in the selectedProducts array. This is
     * the only place on the site where this is possible, so we only need to handle includedDiscounts differently.
     */
    const skuSet = new Set();
    selectedProducts.forEach(({ sku, category, price, quantity }) => {
        var _a, _b, _c, _d, _e, _f;
        const surplus = ((_a = surplusDiscounts[sku]) === null || _a === void 0 ? void 0 : _a.discountAmount) || 0;
        const value = ((_b = valueDiscounts[sku]) === null || _b === void 0 ? void 0 : _b.discountAmount) || 0;
        const sitewide = ((_c = sitewideDiscounts[sku]) === null || _c === void 0 ? void 0 : _c.discountAmount) || 0;
        const included = skuSet.has(sku) ? 0 : (((_d = includedDiscounts[sku]) === null || _d === void 0 ? void 0 : _d.discountAmount) || 0); // zero out included discount if already counted for the same SKU
        if (included && isPercentagePromo) {
            discountAmount += included;
            // TODO one off for this specific coupon look into making this more generic for these kinds of coupons
        }
        else if (category === 'bedding' && couponCode === 'TESTBEDDINGPD14376' && fullPrice > 100) {
            if (sku in valueDiscounts) {
                price = price - (((_e = valueDiscounts[sku]) === null || _e === void 0 ? void 0 : _e.discountAmount) / quantity);
                discountAmount += (_f = valueDiscounts[sku]) === null || _f === void 0 ? void 0 : _f.discountAmount;
            }
            discountAmount += (price * 0.2 * quantity);
        }
        else {
            discountAmount += surplus + value + sitewide + included;
        }
        skuSet.add(sku);
    });
    // consolidate discounts by label into a summary list
    const discounts = [...Object.values(surplusDiscounts), ...Object.values(includedDiscounts), ...Object.values(valueDiscounts), ...Object.values(sitewideDiscounts)];
    const discountSummaryMap = discounts.reduce((acc, { label, sku, discountAmount, discountType }) => {
        if (acc[label]) {
            acc[label].discountAmount += discountAmount;
            acc[label].skus.push(sku);
        }
        else {
            acc[label] = {
                label,
                discountAmount,
                discountType,
                skus: [sku]
            };
        }
        return acc;
    }, {});
    const discountSummaryByLabel = Object.values(discountSummaryMap);
    /**
     * This originally used only Math.floor() but floating point errors in the loop above caused the discounts to be off.
     * Even being off by a fraction of a cent would cause the display to be wrong by a dollar.
     * Calling toFixed(2) will round to the nearest cent first, allowing for a better rounding of the discounts.
     */
    if (roundDiscount) {
        discountAmount = Math.floor(discountAmount.toFixed(2));
        valueDiscountsSum = Math.floor(valueDiscountsSum.toFixed(2));
        surplusDiscountsSum = Math.floor(surplusDiscountsSum.toFixed(2));
        sitewideDiscountsSum = Math.floor(sitewideDiscountsSum.toFixed(2));
        includedDiscountsSum = Math.floor(includedDiscountsSum.toFixed(2));
    }
    const finalPrice = fullPrice - discountAmount;
    return {
        fullPrice,
        discountAmount,
        finalPrice,
        breakdown: {
            valueDiscount: valueDiscountsSum,
            surplusDiscount: surplusDiscountsSum,
            sitewideDiscount: sitewideDiscountsSum,
            includedDiscount: includedDiscountsSum
        },
        labelBreakdown: discountSummaryByLabel
    };
};
exports.getDiscounts = getDiscounts;
/**
 * Add to each item the lower and upper discounted prices according to sizes, mainly used for sorting.
 *
 * When applying discounts we need to find the lowest and highest possible value after the discounts
 * across all possible sizes (or the ones selected by the user), as in some cases, discounts break
 * the assumption that the smallest size will always be the cheapest and the biggest size will be the
 * more expensive.
 * @param {{
*  sku: string,
*  category: string,
*  lowestPrice: number,
*  highestPrice: number,
*  configurableAttributes: string[]
*  variants: {
*      sku: string,
*      productCode: string,
*      category: string,
*      price: number,
*  }[],
* }[]} itemList
* @param {Function} getDiscounts - getDiscounts returned by useGetDiscounts hook (its wrapped internaly by the promo data from context)
* @param {Array<{ key: string, value: string }>} selectedSizes - holds up the user selected sizes
*/
const applyDiscounts = (itemList, getDiscounts, selectedSizes = []) => {
    return itemList.map(item => {
        const { lowestPrice, highestPrice } = item;
        const discountedPrices = [];
        item.variants.forEach((variant) => {
            const hasSize = item.configurableAttributes.includes('size');
            const hasSizeSelected = selectedSizes.some(size => {
                var _a, _b;
                return ((_a = size === null || size === void 0 ? void 0 : size.value) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === ((_b = variant.size) === null || _b === void 0 ? void 0 : _b.toLowerCase());
            });
            if (selectedSizes.length > 0 && hasSize && !hasSizeSelected) {
                return;
            }
            const { finalPrice } = getDiscounts([{
                    sku: variant.sku,
                    parentSku: variant.productCode,
                    category: variant.category,
                    price: variant.price,
                    quantity: 1
                }]);
            discountedPrices.push(finalPrice);
        });
        const lowestPriceDiscount = discountedPrices.length > 0 ? Math.min(...discountedPrices) : lowestPrice;
        const highestPriceDiscount = discountedPrices.length > 0 ? Math.max(...discountedPrices) : highestPrice;
        return {
            ...item,
            // Only should be used for sorting
            lowerPrice: lowestPriceDiscount,
            upperPrice: highestPriceDiscount
        };
    });
};
exports.applyDiscounts = applyDiscounts;
//# sourceMappingURL=promotions.utils.js.map